import React, { Suspense, lazy } from 'react';
import './styles/globals.css';
import './styles/animations.css';
//import './styles/header.css';
import './styles/hero.css';
import './styles/buttons.css';
//import './styles/about.css';
//import './styles/skills.css';
//import './styles/projects.css';
//import './styles/contact.css';
//import './styles/footer.css';
import './styles/responsive.css';

import './styles/header-section.css';
import './styles/education-section.css';
import './styles/about-section.css';
import './styles/projects-section.css';
import './styles/contact-section.css';
import './styles/footer-section.css';

import Header from './components/Header';
import Footer from './components/Footer';



const About = lazy(() => import('./components/About'));
const Skills = lazy(() => import('./components/Skills'));
const Projects = lazy(() => import('./components/Projects'));
const Contact = lazy(() => import('./components/Contact'));


const LoadingFallback = () => (
  <div style={{ padding: '60px 20px', textAlign: 'center', minHeight: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <p style={{ fontSize: '18px', color: '#666' }}>Loading...</p>
  </div>
);

function App() {
  return (
    <div className="App">
      <Header />
      <Suspense fallback={<LoadingFallback />}>
        <About />
      </Suspense>
      <Suspense fallback={<LoadingFallback />}>
        <Skills />
      </Suspense>
      <Suspense fallback={<LoadingFallback />}>
        <Projects />
      </Suspense>
      <Suspense fallback={<LoadingFallback />}>
        <Contact />
      </Suspense>
      <Footer />
    </div>
  );
}

export default App;